/* tslint:disable */

declare var Object: any;
export interface TypeInterface {
  "name"?: string;
  "createdat"?: Date;
  "updatedat"?: Date;
  "id"?: number;
}

export class Type implements TypeInterface {
  "name": string;
  "createdat": Date;
  "updatedat": Date;
  "id": number;
  constructor(data?: TypeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Type`.
   */
  public static getModelName() {
    return "Type";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Type for dynamic purposes.
  **/
  public static factory(data: TypeInterface): Type{
    return new Type(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Type',
      plural: 'Types',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "createdat": {
          name: 'createdat',
          type: 'Date'
        },
        "updatedat": {
          name: 'updatedat',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk-budget/models/Type.ts